export function getPrefix(idTemplate, previousUrl) {
  switch (idTemplate) {
    case "enterprise_profile":
      return `/library/${idTemplate}`

    case "organization":
      return previousUrl.includes("/enterprise/form/organization/")
        ? `/enterprise/form/${idTemplate}`
        : `/form/${idTemplate}`

    case "staff":
    case "location":
    case "program":
      return previousUrl.includes("/enterprise/form/staff/")
        ? `/enterprise/form/${idTemplate}`
        : `/organization/form/${idTemplate}`

    default:
      return `/form/${idTemplate}`
  }
}

function findFieldLabelRecursive(fieldName, fieldsConfig) {
  if (!fieldsConfig || !Array.isArray(fieldsConfig)) {
    return null;
  }

  for (const field of fieldsConfig) {
    if (field.field_name === fieldName && field.field_label) {
      return field.field_label;
    }
    if (field.multi_fields && field.multi_fields.length > 0) {
      const labelInMultiField = findFieldLabelRecursive(fieldName, field.multi_fields);
      if (labelInMultiField) {
        return labelInMultiField;
      }
    }
  }
  return null;
}

function formatErrorsForToast(errors, fieldsConfig, indent = 0) {
  let errorList = ''
  const indentation = '\u00A0\u00A0'.repeat(indent) // using non-breaking spaces

  for (const key in errors) {
    if (Object.prototype.hasOwnProperty.call(errors, key)) {
      const value = errors[key];
      let displayKey = key;

      // Try to find the field label
      const fieldLabel = findFieldLabelRecursive(key, fieldsConfig);
      if (fieldLabel) {
        displayKey = fieldLabel;
      } else {
        // Fallback to existing logic if no field_label is found
        displayKey = isNaN(key)
          ? key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
          : `Item ${Number(key) + 1}`;
      }

      if (typeof value === 'string') {
        errorList += `<div>${indentation}• ${displayKey}: ${value}</div>`
      } else if (typeof value === 'object' && value !== null) {
        errorList += `<div>${indentation}• ${displayKey}:</div>`
        errorList += formatErrorsForToast(value, fieldsConfig, indent + 1) // Pass fieldsConfig recursively
      }
    }
  }
  return errorList
}

export function getFormValidationToast(errors, fieldsConfig) {
  const baseToast = {
    severity: "warn",
    summary: "Missing required fields",
    detail: "The form has required fields that are incomplete. Please fill them before navigating.",
    sticky: true,
  }

  if (errors) {
    const errorDetails = formatErrorsForToast(errors, fieldsConfig)
    const errorHeader = '<br /><br /><b>Validation errors:</b>'
    baseToast.detail = <div dangerouslySetInnerHTML={{ __html: baseToast.detail + errorHeader + errorDetails }} />
  }

  return baseToast
}

export function smoothScrollToTop() {
  // Smooth scroll to top of form
  const bodyMain = document.querySelector(".body-main")
  if (bodyMain) {
    const currentScrollTop = bodyMain.scrollTop
    const duration = 400 // Scroll animation duration in milliseconds
    const startTime = performance.now()
    const scrollStep = (timestamp) => {
      const elapsed = timestamp - startTime
      const progress = Math.min(elapsed / duration, 1)
      bodyMain.scrollTop = currentScrollTop * (1 - progress)

      if (progress < 1) {
        requestAnimationFrame(scrollStep)
      }
    }
    requestAnimationFrame(scrollStep)
  }
}